import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Page404 from '../error/404'
import Customer from '../../pages/roles/UserRole';

export default function PrivateCustomerRoutes() {
    return (
        <div>
            <Switch>
                <Route
                    exact
                    path='/profile'
                    component={Page404}
                />
                <Route
                    exact
                    path='/support'
                    component={Page404}
                />
                <Route
                    exact
                    path='/'
                    component={Customer}
                />
            </Switch>
        </div>
    )
}